<template>
  <div class="update-item update-item-modal">
    <div class="modal task">
      <div class="modal-close" @click="close"></div>
      <div class="custom-modal-header">Update Item</div>
      <div class="content">
        <div>
          <div class="run-task-button" v-b-tooltip.hover title="Ausführen">
            <span v-if="!isTaskRunning" class="run-task" @click="runTask()">
              <i class="fas fa-play"></i>
            </span>
            <b-spinner
              v-if="isTaskRunning"
              class="call-spinner"
              label="Spinning"
            ></b-spinner>
          </div>
        </div>
        <div class="header">
          <div class="row">
            <div class="filename-wrapper col-4">
              <input
                type="text"
                v-model="task.props.elementName"
                class="props-input"
                ref="report-name"
                placeholder="Definieren Sie den Namen für das Resultat"
                :disabled="!isUserHasAccess"
                :class="{ 'is-duplicate': isNameDuplicate(), error: shakeName }"
              />
            </div>
            <div
              class="search-wrapper"
              v-click-outside="hideSearch"
              :class="{ active: searchActive }"
            >
              <div class="search-btn" @click="toggleSearch">
                <img src="../../assets/img/search-icon.svg" />
              </div>
              <input class="search-input" ref="search" v-model="search" />
            </div>
          </div>
        </div>

        <div class="database-drop-down">
          <div class="tab">
            <SelectDatabase
              :selectedDatabaseCaption="selectedDatabaseCaption"
              :selectedDatabaseName="selectedDatabaseName"
              :userTables="userTables"
              componentName="update-item"
              @onDatabaseSelect="onDatabaseSelect"
              :isUserHasAccess="isUserHasAccess"
              @onRemoveSelectedDatabase="onRemoveSelectedDatabase"
            />
          </div>
          <div class="button-wrapper">
            <button
              v-if="isAutoFillButtonVisible"
              class="auto-fill-button"
              @click="onAutoFill"
              :disabled="!isUserHasAccess"
            >
              Automatisch befüllen
            </button>
          </div>

          <div class="tab item-content-wrapper">
            <LoadingSpinner loadingCaption="loading schema" v-if="isLoading" />
            <div v-else>
              <div class="item-form">
                <div class="input-attributes">
                  <label>Id*</label>
                  <input
                    type="text"
                    v-model="task.props.userInputItemId"
                    :disabled="!isUserHasAccess"
                  />

                  <div
                    v-if="getDropdownItems.length"
                    class="custom-dropdown-id"
                  >
                    <generalDropdown :disabled="!isUserHasAccess">
                      <template v-slot:optionData>
                        <b-dropdown-item
                          v-for="content in getDropdownItems"
                          :key="content.label"
                          @click="onOptionSelect(content.name, null, true)"
                        >
                          {{ content.name }}
                        </b-dropdown-item>
                      </template>
                    </generalDropdown>
                  </div>
                  <div class="empty-div"></div>
                </div>
              </div>
              <div
                v-if="getFilteredData.length"
                v-for="(item, index) of getFilteredData"
                :key="item.name + '--' + index"
                class="item-form"
              >
                <div class="input-attributes">
                  <label>{{ item.label }} </label>
                  <input
                    type="text"
                    @input="onInputChange($event, item.name)"
                    :value="item.value"
                    :disabled="!isUserHasAccess"
                  />
                  <div v-if="getDropdownItems.length" class="custom-dropdown">
                    <generalDropdown :disabled="!isUserHasAccess">
                      <template v-slot:optionData>
                        <b-dropdown-item
                          v-for="content in getDropdownItems"
                          :key="content.label"
                          @click="
                            onOptionSelect(content.name, item.name, false)
                          "
                        >
                          {{ content.name }}
                        </b-dropdown-item>
                      </template>
                    </generalDropdown>
                  </div>
                  <div
                    class="btn-close"
                    @click="removeItemContent(item.name)"
                  ></div>
                </div>
              </div>
            </div>
          </div>

          <!-- add new element in update item -->
          <div
            v-if="filterSchema.length"
            class="add-new-fields-dropdown-wrapper"
          >
            <generalDropdown
              class="add-new-fields-dropdown"
              :disabled="!isUserHasAccess"
            >
              <template v-slot:iconContainer>
                <PlusIconButton />
              </template>
              <template v-slot:optionData>
                <b-dropdown-item
                  v-for="content in filterSchema"
                  :key="content.name"
                  @click="onAddNewUpdateItemContent(content)"
                >
                  {{ content.label }}
                </b-dropdown-item>
              </template>
            </generalDropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import PlusIconButton from '../widgets/PlusIconButton.vue';
import {
  getDataBaseTableSchema,
  getUserDatabases,
} from '../../services/userTable';
import GeneralDropdown from '../core/general-dropdown.vue';
import { mapGetters, mapActions } from 'vuex';
import { isValidTaskName, getPlaceHolderValue } from '@/utils/helpers';
import { getDefaultTaskName } from '@/utils/helpers/WorkFlowHelpers.js';
import SelectDatabase from '../../components/SelectDatabase.vue';
import { updateDatabaseItem } from '@/services/axios/data.api.js';

import {
  getInputPlaceholderList,
  getApiEndpointVersion,
  LATEST_FLOW_RUNNER_VERSION,
  getInterpolatedValue,
} from '@/utils/helpers.js';

export default {
  name: 'UpdateItem',
  data() {
    return {
      isLoading: false,
      userTables: [],
      itemContent: [],
      // elementName: '',
      selectedDatabaseName: null,
      selectedDatabaseSchema: null,
      selectedDatabaseCaption: null,
      shakeName: false,
      isTaskRunning: false,
      searchActive: false,
      search: '',
    };
  },
  props: {
    task: Object,
    isUserHasAccess: { type: Boolean, default: true },
    getFileNamesFromProps: {
      type: Function,
      required: true,
      default: () => {},
    },
    flowRunnerEndpoint: {
      type: String,
    },
  },
  methods: {
    ...mapActions(['setDatabaseSchema']),
    close: async function () {
      if (
        this.isNameDuplicate() ||
        !this.task.props.elementName ||
        this.task.props.elementName === null ||
        this.task.props.elementName.trim() === '' ||
        !isValidTaskName(this.task.props.elementName)
      ) {
        this.shakeName = true;
        setTimeout(() => {
          this.shakeName = false;
        }, 500);
        return;
      }
      if (
        this.selectedDatabaseName &&
        (!this.task.props.userInputItemId ||
          this.task.props.userInputItemId === null ||
          this.task.props.userInputItemId.trim() === '')
      ) {
        this.showToaster(
          'Bitte füllen Sie die Id aus.',
          'Fehlerhaft !',
          'danger'
        );
        return;
      }
      let value = {
        message: this.itemContent.length !== 0 ? 'success' : 'fail',
        id: this.task.props.userInputItemId,
      };
      for (const item of this.itemContent) {
        value[item.name] = item.value;
      }
      let outputResponse = {
        label: this.task.props.elementName,
        name: this.task.props.elementName,
        type: 'JSON',
        value,
      };
      this.task.output = [];
      let outputObjectIndex = [...this.task.output].findIndex(
        (ele) =>
          ele.caption === this.task.props.elementName &&
          ele.label === this.task.props.elementName
      );
      if (outputObjectIndex > -1) {
        this.task.output[outputObjectIndex] = outputResponse;
      } else {
        this.$set(this.task, 'output', this.task.input.concat(outputResponse));
      }
      this.task.props.database = this.selectedDatabaseName;
      this.task.props.itemContent = this.itemContent;
      this.$emit('close');
    },
    async onDatabaseChange(database) {
      try {
        await this.onDatabaseSelect(database);
        this.task.props.userInputItemId = null;
      } catch (error) {}
    },
    async onDatabaseSelect(database) {
      this.search = '';
      const selectedDatabase = this.userTables.find(
        (userTable) => userTable.name.trim() === database.name.trim()
      );
      if (!selectedDatabase) return;
      try {
        this.isLoading = true;
        if (!selectedDatabase?.schema) {
          const response = await getDataBaseTableSchema(selectedDatabase.name);
          this.setDatabaseSchema(response.data);
          this.selectedDatabaseSchema = response.data.data;
        } else {
          this.selectedDatabaseSchema = selectedDatabase.schema;
        }
        this.selectedDatabaseName = selectedDatabase.name;
        this.selectedDatabaseCaption = selectedDatabase.caption;
        // this.userInputId = '';
        this.itemContent = this.filteredOutElements.map((schema) => {
          return {
            name: schema.name,
            label: schema.label,
            value: '',
          };
        });
      } catch (error) {
      } finally {
        this.isLoading = false;
      }
    },
    isNameDuplicate() {
      const htmlFilenames = this.getFileNamesFromProps(this.task.id);
      return htmlFilenames.includes(this.task.props.elementName);
    },
    removeItemContent(itemName) {
      const index = this.itemContent.findIndex(
        (item) => item.name === itemName
      );
      this.itemContent.splice(index, 1);
    },
    onAutoFill() {
      this.filteredOutElements.forEach((field) => {
        const matchingInput = this.task.input.find(
          (input) => input.name === field.name
        );
        if (matchingInput) {
          const findIndex = this.itemContent.findIndex(
            (item) => item.name === matchingInput.name
          );
          if (findIndex !== -1) {
            this.itemContent[findIndex].value = `{${matchingInput.name}}`;
          }
        }
      });
    },
    onOptionSelect(contentName, itemName, isIdInput) {
      const index = this.itemContent.findIndex(
        (item) => item.name === itemName
      );
      if (contentName.includes(':')) {
        if (isIdInput) {
          this.task.props.userInputItemId = `{${contentName}}`;
        } else {
          this.itemContent[index].value = `{${contentName}}`;
        }
      } else {
        const selectedInput = this.task.input.find(
          (input) => input.name === contentName
        );
        if (selectedInput) {
          if (isIdInput) {
            this.task.props.userInputItemId = `{${selectedInput.name}}`;
          } else {
            this.itemContent[index].value = `{${selectedInput.name}}`;
          }
        }
      }
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    onAddNewUpdateItemContent(item) {
      this.itemContent.push({ label: item.label, name: item.name, value: '' });
    },
    async runTask() {
      try {
        if (!this.getDatabaseRecordId) return;
        this.isTaskRunning = true;
        const updatedContent = this.itemContent.reduce((acc, curr) => {
          acc[curr['name']] = getPlaceHolderValue(
            curr['value'],
            this.task.input
          );
          return acc;
        }, {});
        const itemId =
          typeof this.getDatabaseRecordId === 'number'
            ? this.getDatabaseRecordId
            : this.getDatabaseRecordId &&
              !isNaN(Number(this.getDatabaseRecordId)) &&
              String(this.getDatabaseRecordId).trim() !== ''
            ? Number(this.getDatabaseRecordId)
            : this.getDatabaseRecordId;

        const updatedPayload = {
          item: {
            id: itemId,
            ...updatedContent,
          },
        };
        await updateDatabaseItem(this.selectedDatabaseName, updatedPayload);
      } catch (error) {
        this.showToaster(
          'Fehler beim Aktualisieren des Elements',
          'Fehlerhaft !',
          'danger'
        );
      } finally {
        this.isTaskRunning = false;
      }
    },
    toggleSearch() {
      this.searchActive = true;
      if (this.searchActive) {
        this.$refs.search.focus();
      }
    },
    hideSearch() {
      if (this.search.trim() === '') {
        this.$refs.search.blur();
        this.search = '';
        this.searchActive = false;
      }
    },
    onInputChange(e, itemName) {
      const index = this.itemContent.findIndex((el) => el.name === itemName);
      if (index > -1) {
        if (e?.target?.value) {
          this.itemContent[index].value = e.target.value;
        } else {
          this.itemContent[index].value = '';
        }
      }
    },
    onRemoveSelectedDatabase() {
      this.selectedDatabaseName = null;
      this.selectedDatabaseSchema = null;
      this.selectedDatabaseCaption = null;
      this.itemContent = [];
    },
  },
  computed: {
    ...mapGetters({ databaseList: 'getDatabaseList' }),
    getFilteredData() {
      const tempArr = [];
      this.filteredOutElements.map((schema) => {
        const itemValue = this.itemContent?.find(
          (el) => el.name == schema.name
        );
        if (itemValue) {
          tempArr.push({
            name: schema.name,
            label: schema.label,
            value: itemValue?.value || '',
          });
        }
      });
      return tempArr;
    },
    filteredOutElements() {
      if (this.selectedDatabaseSchema) {
        const disabledElementType = [
          'image',
          'video',
          'html',
          'title',
          'description',
          'horizontalrule',
          'togglelist',
          'wrapper',
          'divwrapper',
        ];
        let filteredSchema = JSON.parse(this.selectedDatabaseSchema)?.filter(
          (schema) => !disabledElementType.includes(schema.type)
        );
        if (this.searchActive) {
          filteredSchema = filteredSchema?.filter(
            (el) =>
              el.label?.toLowerCase().includes(this.search.toLowerCase()) ||
              this.itemContent
                .find((item) => item.name === el.name)
                ?.value?.toLowerCase()
                .includes(this.search.toLowerCase())
          );
        }

        return filteredSchema;
      }

      return [];
    },
    filterSchema() {
      return this.filteredOutElements.filter((item) => {
        return !this.itemContent.some(
          (inputItem) => inputItem.name == item.name
        );
      });
    },

    filterDataBase() {
      if (this.userTables.length) {
        return this.userTables;
      }
      return [];
    },
    isAutoFillButtonVisible() {
      return (
        this.selectedDatabaseSchema &&
        this.task?.input?.length &&
        this.itemContent.length
      );
    },
    getDropdownItems() {
      const apiVersion =
        getApiEndpointVersion(this.flowRunnerEndpoint) ||
        LATEST_FLOW_RUNNER_VERSION;
      return getInputPlaceholderList(this.task.input, apiVersion, [], true);
    },
    getDatabaseRecordId() {
      return getInterpolatedValue(
        this.task.props.userInputItemId,
        this.task.input
      );
    },
  },
  async created() {
    try {
      let customTables;
      if (this.databaseList.length) {
        customTables = this.databaseList;
      } else {
        customTables = await getUserDatabases();
      }
      this.userTables = customTables.filter(
        (database) =>
          database.type === 'custom' &&
          !['read'].includes(database.access_level)
      );
      if (this.task.props.database) {
        await this.onDatabaseSelect({ name: this.task.props.database });
      }
      this.itemContent = this.task.props.itemContent;
      if (!this.task?.props?.elementName) {
        const existingTaskNames = this.getFileNamesFromProps(this.task.id);
        this.task.props.elementName = getDefaultTaskName(
          existingTaskNames,
          'UpdateItem_Antwort'
        );
      }
      this.elementName = this.task.props.elementName;
      this.itemContent = this.task.props.itemContent;
    } catch (error) {}
  },
  components: {
    GeneralDropdown,
    LoadingSpinner,
    PlusIconButton,
    SelectDatabase,
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.update-item-modal {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.update-item input,
select {
  font-family: 'Open Sans', open-sans, sans-serif;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 15px;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  line-height: 19px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 19px;
  font-weight: 300;
}
.update-item .input-attributes {
  display: flex;
  align-items: center;
  gap: 15px;
}
.update-item .input-attributes input {
  width: 100%;
  border: 1px solid #dee3e9;
  border-radius: 0.375rem;
  padding: 10px 15px;
  cursor: text;
  height: auto;
  margin-bottom: 0px !important;
  font-size: 13px;
  font-weight: 500;
}

.update-item .content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

.update-item h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

.update-item .tab {
  text-align: left;
  width: 100%;
  padding: 20px 0px;
}

.update-item select {
  width: 70%;
}

.update-item button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 25px;
}

.update-item button.default {
  color: #464d5d;
  background: #fff;
}
.update-item .pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 7px;
}
.update-item .database-drop-down {
  display: flex;
  flex-direction: column;
}

.update-item .select-operation {
  background-color: #ffffff;
  border: 1px solid #dee3e9;
  height: 50px;
  width: 100%;
}

.update-item .select-operation ::v-deep button {
  justify-content: space-between;
}

.update-item .select-operation ::v-deep .dropdown-menu {
  width: 100% !important;
}
.update-item .modal .database-modal {
  position: absolute;
  right: 10px;
  top: 10px;
}

.update-item .modal .database-modal .btn-close {
  margin-left: auto;
}
.update-item .btn-close-id,
.update-item .header .filename-wrapper {
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  color: #464d5d;
}

.update-item .header .props-input {
  font-size: 15px !important;
  line-height: 28px !important;
  cursor: text !important;
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  color: #000 !important;
  border: 1px solid #e2e2e2 !important;
  border-radius: 6px !important;
  padding: 12px 12px !important;
  height: 38px !important;
}

@keyframes progress-icon-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.update-item .header .props-input:focus {
  outline: none;
}
.update-item .header .is-duplicate {
  background: #ff050578;
}
.update-item .header .error {
  animation: shake 0.2s ease-in-out 0s 2;
  border: none;
  box-shadow: 0 0 0.5em red;
}
@keyframes shake {
  0% {
    margin-left: 2rem;
  }
  25% {
    margin-left: 2.2rem;
  }
  75% {
    margin-left: 1.8rem;
  }
  100% {
    margin-left: 2rem;
  }
}
.update-item .item-form .input-attributes {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
.update-item .item-form .input-attributes label {
  min-width: 250px;
  display: block;
  text-align: left;
  padding-right: 15px;
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.update-item .item-form .input-attributes .empty-div {
  width: 16px;
}
.update-item .item-form .input-attributes input {
  width: calc(100% - 250px);
  border: 1px solid #dee3e9;
  border-radius: 0.375rem;
  padding: 10px 15px;
  cursor: text;
  height: auto;
  font-family: 'Aktiv Grotesk';
  font-weight: 500;
  color: #5f697a;
  line-height: unset;
}
.update-item .item-form .input-attributes input:focus {
  outline: none;
}

.update-item .button-wrapper {
  text-align: center;
}
.update-item .auto-fill-button {
  height: 45px;
  width: max-content;
  text-decoration: none;
  color: #fff;
  border: 3px solid #000;
  border-radius: 0.375em;
  cursor: pointer;
  display: inline-block;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 700;
  line-height: 23px;
  padding: 0.5rem 1.5rem;
  font-size: 0.9375rem;
  opacity: 1;
  transition: transform 0.2s linear 0s, background-color 0.2s linear 0s;
  transform: translateY(0) scale(1.001);
  background-color: #000;
  margin: 0;
  text-transform: none;
}
.custom-dropdown ul {
  position: absolute;
  padding: 0;
  background: #fff;
  list-style: none;
  width: 130px;
  margin: 5px auto 0;
  left: 10px;
  top: 30px;
  color: #333;
  border: 1px solid #dbdbdb;
  text-align: initial;
  border-radius: 4px 4px 4px 4px;
  z-index: 1;
}
.update-item-modal .content {
  height: calc(100% - 36px - 17px);
  margin-top: 17px;
}
.update-item-modal .content .header {
  margin: 0 0 0 0;
}

.update-item-modal .database-drop-down {
  height: calc(100% - 38px - 36px);
  margin-top: 36px;
}

.update-item-modal .item-content-wrapper {
  height: calc(100% - 178px);
  overflow-y: auto;
}

.update-item-modal .modal {
  overflow-y: hidden;
}

.update-item-modal ::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
.update-item-modal ::v-deep .toast:not(.show) {
  display: block;
}

.update-item-modal
  .add-new-fields-dropdown
  ::v-deep
  .dropdown-toggle
  .dropdown-toggle-icon {
  display: none;
}

.update-item-modal .add-new-fields-dropdown-wrapper {
  display: flex;
  justify-content: center;
}
.update-item-modal .add-new-fields-dropdown ::v-deep .dropdown-toggle {
  box-shadow: none;
}

.update-item-modal .add-new-fields-dropdown ::v-deep .dropdown-menu {
  bottom: 10px !important;
  top: unset !important;
  transform: unset !important;
  left: 75px !important;
}
.update-item-modal .item-content-wrapper ::v-deep .progress-icon-wrapper {
  z-index: 1 !important;
}
.update-item-modal .input-group .disable-pointer-events {
  pointer-events: none;
}

.update-item-modal .run-task-button {
  position: absolute;
  top: 32px;
  left: 36px;
  height: 42px;
  width: 42px;
  color: #000;
  background: #fff;
  transition: color 0.15s;
}

.update-item-modal .run-task-button .run-task {
  border: 1px solid #dbdde0;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.13);
  font-size: 14px;
  height: 42px;
  width: 42px;
  cursor: pointer;
}
.call-spinner {
  color: #7e8890;
}
.update-item .search-wrapper {
  border: none;
  outline: none;
  border-radius: 5px;
  width: fit-content;
  transition: all 0.5s ease;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0 12px 0 auto !important;
  position: relative;
  min-width: 40px;
}

.update-item .search-wrapper .search-input {
  border: 1px solid transparent;
  outline: none;
  height: 36px !important;
  margin: 0 !important;
  padding: 0 !important;
  width: 0;
  max-width: 260px;
  display: flex;
  align-items: center;
  transition: all 0.5s ease;
  display: flex;
  align-items: center;
  font-size: 15px !important;
  border-radius: 5px;
  overflow: hidden;
}

.update-item .search-wrapper.active .search-input {
  width: 260px;
  padding-inline: 38px 15px !important;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.update-item .search-wrapper .search-btn {
  border: none;
  outline: none;
  background-color: transparent;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  transition: all 0.5s ease;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
}

.update-item .search-wrapper .search-btn img {
  width: 18px;
  height: 18px;
  object-fit: contain;
  object-position: center;
}
</style>
